import type { UseMutationOptions } from "@tanstack/react-query";
import { apiRequest, type ApiError, useApiMutation } from "@/shared/api";

export type PhoneOtpResponse = {
  status: string;
};

export type RequestPhoneVerificationPayload = {
  phoneNumber: string;
};

export type VerifyPhoneUpdatePayload = {
  phoneNumber: string;
  otp: string;
};

const requestPhoneUpdateRequest = (
  payload: RequestPhoneVerificationPayload
) => ({
  url: "/profile/update-phone",
  method: "post" as const,
  data: payload,
});

const verifyPhoneUpdateRequest = (payload: VerifyPhoneUpdatePayload) => ({
  url: "/profile/verify-phone-update",
  method: "post" as const,
  data: payload,
});

export const requestPhoneUpdateOtp = (
  payload: RequestPhoneVerificationPayload
) => apiRequest<PhoneOtpResponse>(requestPhoneUpdateRequest(payload));

export const verifyPhoneUpdateOtp = (payload: VerifyPhoneUpdatePayload) =>
  apiRequest<PhoneOtpResponse>(verifyPhoneUpdateRequest(payload));

export const useRequestPhoneUpdateOtp = (
  options?: UseMutationOptions<
    PhoneOtpResponse,
    ApiError,
    RequestPhoneVerificationPayload
  >
) => useApiMutation(requestPhoneUpdateRequest, options);

export const useVerifyPhoneUpdateOtp = (
  options?: UseMutationOptions<
    PhoneOtpResponse,
    ApiError,
    VerifyPhoneUpdatePayload
  >
) => useApiMutation(verifyPhoneUpdateRequest, options);
